import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'table-entity-configuration',
    templateUrl: './entity-configuration.component.html',
    styleUrls: ['./entity-configuration.component.scss'],
})
export class TableEntityConfigurationComponent implements OnInit {


    @Input('data') config;

    constructor() { }

    ngOnInit() { }

    // Método para alternar a visibilidade do Client Secret
    toggleSecretVisibility(item: any): void {
        item.showSecret = !item.showSecret;
    }

    // Método para alternar a visibilidade do Token
    toggleTokenVisibility(item: any): void {
        item.showToken = !item.showToken;
    }

    // Método para alternar a visibilidade da License Key
    toggleLicenseVisibility(item: any): void {
        item.showLicense = !item.showLicense;
    }

    // Método para alternar a visibilidade da Password
    togglePasswordVisibility(item: any): void {
        item.showPassword = !item.showPassword;
    }

    // Método para formatar a informação da conta (ex: JSON)
    formatAccountInfo(account: string): string {
        if (!account) return '';

        try {
            const accountObj = JSON.parse(account);
            return JSON.stringify(accountObj, null, 2);
        } catch (e) {
            return account;
        }
    }

}
